import { fieldRegistry } from '../../../core/fields/registry/FieldRegistry';
import { baseFieldPack } from './packs/base.pack';
import { medicalGeneticFieldPack } from './packs/medical-genetic.pack';
import { legalEstateFieldPack } from './packs/legal-estate.pack';
import { socialWorkFieldPack } from './packs/social-work.pack';
import { familyTherapyFieldPack } from './packs/family-therapy.pack';
import { generalResearchFieldPack } from './packs/general-research.pack';

export const GENOGRAM_FIELD_PACKS = [
  baseFieldPack,
  medicalGeneticFieldPack,
  legalEstateFieldPack,
  socialWorkFieldPack,
  familyTherapyFieldPack,
  generalResearchFieldPack,
] as const;

export function registerGenogramFieldPacks(): void {
  for (const pack of GENOGRAM_FIELD_PACKS) fieldRegistry.registerPack(pack);
}

export * from './packs/base.pack';
export * from './packs/medical-genetic.pack';
export * from './packs/legal-estate.pack';
export * from './packs/social-work.pack';
export * from './packs/family-therapy.pack';
export * from './packs/general-research.pack';
